import React from "react";
import Styles from "./SelfListingBand.module.css";

const formatDateRange = (slot) => {
  if (!slot?.dateStartAt || !slot?.dateEndAt) return "—";
  return `${String(slot.dateStartAt).replace(/-/g, " ")} - ${String(
    slot.dateEndAt,
  ).replace(/-/g, " ")}`;
};

const formatEndTime = (timeStr) => {
  if (!timeStr) return "";
  return timeStr.startsWith("23:59") ? "24:00" : timeStr;
};

const formatTimeRange = (slot) => {
  if (!slot?.slotStartAt) return "";
  return `${slot.slotStartAt} - ${formatEndTime(slot.slotEndAt)}`;
};

const SelfListingBand = ({ selfListing, listingName, onViewAll }) => {
  if (!selfListing) return null;

  const injectSlot = selfListing.bankingSlotInjects?.[0];
  const drawalSlot = selfListing.bankingSlotDrawls?.[0];

  return (
    <div className={Styles.selfBandWrap}>
      <div className={Styles.selfBandHeader}>
        {/* <span className={Styles.selfBandBar} /> */}
        <span className={Styles.selfBandLabel}>Self Listing Details</span>
      </div>

      <div className={Styles.selfBand}>
      {(listingName || selfListing?.name) && (
        <div className={Styles.selfBandListingId} title={listingName || selfListing?.name}>
          {listingName || selfListing?.name}
        </div>
      )}
      <div className={Styles.selfBandViewAllRow}>
        <span
          className={Styles.selfBandViewAll}
          onClick={() => onViewAll?.(selfListing)}
        >
          View All Requisitions
        </span>
      </div>
      <div className={Styles.selfBandMetrics}>
        <div className={Styles.metric}>
          <span className={Styles.metricKey}>Injection Range</span>
          <span className={Styles.metricVal}>{formatDateRange(injectSlot)}</span>
          {injectSlot && (
            <span className={Styles.metricTime}>
              {formatTimeRange(injectSlot)}
            </span>
          )}
        </div>

        <div className={Styles.metric}>
          <span className={Styles.metricKey}>Drawal Range</span>
          <span className={Styles.metricVal}>{formatDateRange(drawalSlot)}</span>
          {drawalSlot && (
            <span className={Styles.metricTime}>
              {formatTimeRange(drawalSlot)}
            </span>
          )}
        </div>

        <div className={Styles.metric}>
          <span className={Styles.metricKey}>
            BF <span className={Styles.metricUnit}>(%)</span>
          </span>
          <span className={Styles.metricVal}>
            {selfListing.bankingFactor != null
              ? Number(selfListing.bankingFactor).toFixed(2)
              : "—"}
          </span>
        </div>

        <div className={Styles.metric}>
          <span className={Styles.metricKey}>
            SR <span className={Styles.metricUnit}>(₹/kWh)</span>
          </span>
          <span className={Styles.metricVal}>
            {selfListing.settlementRate || 0}
          </span>
        </div>
      </div>
      </div>
    </div>
  );
};

export default SelfListingBand;
